export const environment = {
    REACT_APP_BASE_URL: process.env.REACT_APP_BASE_URL || '',
    REACT_APP_LMS_BASE_URL: process.env.REACT_APP_LMS_BASE_URL || '',
    REACT_APP_WEB_API: process.env.REACT_APP_WEB_API || '',
    REACT_APP_CLIENT_ID: process.env.REACT_APP_CLIENT_ID || '',
    REACT_APP_AUTHORITY: process.env.REACT_APP_AUTHORITY || '',
    REACT_APP_KNOWLEDGE_AUTHORITY: process.env.REACT_APP_KNOWLEDGE_AUTHORITY || '',
    REACT_APP_NCCCO_BASE_URL: process.env.REACT_APP_NCCCO_BASE_URL || '',
    REACT_APP_NCCCO_API_KEY: process.env.REACT_APP_NCCCO_API_KEY || '',
    REACT_APP_HEADERKEY: process.env.REACT_APP_HEADERKEY || '',
    REACT_APP_EXAM_HUB_URL: process.env.REACT_APP_EXAM_HUB_URL || '',
    REACT_APP_DEMO_EXAM_URL: process.env.REACT_APP_DEMO_EXAM_URL || '',
};

